import styled from 'styled-components';

const StyledPasswordInputField = styled.div`
  position: absolute;
  input {
    background: #000;
  }

  p {
    width: 100%;
    position: absolute;
    top: 2.4rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 1.2rem;
    color: red;
  }
`;

function PasswordInputField({ handleValidation, handlePasswordChange, passwordValue, passwordError }) {
  return (
    <StyledPasswordInputField>
      <input type='password' value={passwordValue} onChange={handlePasswordChange} onKeyUp={handleValidation} name='password' placeholder='Password' className='form-control' />
      <p className='text-danger'>{passwordError}</p>
    </StyledPasswordInputField>
  );
}
export default PasswordInputField;
